export const BLOG_READING_THEME_STORAGE_KEY = "blogReadingTheme";
export const DEFAULT_DARK_READING_THEME_ID = "default-dark";
export const DEFAULT_LIGHT_READING_THEME_ID = "default-light";

export const BLOG_READING_THEMES = [
  {
    id: "default-light",
    label: "Default Light",
    mode: "light",
    background: "#EEF2F7",
    surface: "#E1E8F2",
    text: "#1A2233",
    muted: "#516174",
    heading: "#17233D",
    link: "#0F7EC8",
    border: "rgba(15, 126, 200, 0.18)",
  },
  {
    id: "paper",
    label: "Paper",
    mode: "light",
    background: "#F5F0E8",
    surface: "#EEE5D8",
    text: "#2C1A0E",
    muted: "#6A5645",
    heading: "#241307",
    link: "#8A4B16",
    border: "rgba(138, 75, 22, 0.22)",
  },
  {
    id: "sepia",
    label: "Sepia",
    mode: "light",
    background: "#FBF0D9",
    surface: "#F1E1BF",
    text: "#5C4017",
    muted: "#7B6338",
    heading: "#432C0D",
    link: "#9A5C12",
    border: "rgba(92, 64, 23, 0.22)",
  },
  {
    id: "sage",
    label: "Sage",
    mode: "light",
    background: "#EEF2EB",
    surface: "#E1E8DE",
    text: "#1E3A1E",
    muted: "#536A53",
    heading: "#143014",
    link: "#2E7D32",
    border: "rgba(30, 58, 30, 0.2)",
  },
  {
    id: "rose",
    label: "Rose",
    mode: "light",
    background: "#FDF0F0",
    surface: "#F4DDDD",
    text: "#3D1515",
    muted: "#765252",
    heading: "#2B0D0D",
    link: "#A33A3A",
    border: "rgba(61, 21, 21, 0.18)",
  },
  {
    id: "default-dark",
    label: "Default Dark",
    mode: "dark",
    background: "#0D1117",
    surface: "#161B22",
    text: "#C9D4E8",
    muted: "#8B949E",
    heading: "#F0F6FC",
    link: "#0FF0FC",
    border: "rgba(15, 240, 252, 0.18)",
  },
  {
    id: "midnight",
    label: "Midnight",
    mode: "dark",
    background: "#0D0D0D",
    surface: "#171717",
    text: "#E8E8E8",
    muted: "#A7A7A7",
    heading: "#FFFFFF",
    link: "#8AD8FF",
    border: "rgba(232, 232, 232, 0.16)",
  },
  {
    id: "slate",
    label: "Slate",
    mode: "dark",
    background: "#1C2333",
    surface: "#252E42",
    text: "#C9D1E0",
    muted: "#9BA8BD",
    heading: "#E8EEF8",
    link: "#80C7FF",
    border: "rgba(201, 209, 224, 0.16)",
  },
  {
    id: "forest",
    label: "Forest",
    mode: "dark",
    background: "#0F1A0F",
    surface: "#172817",
    text: "#A8D8A8",
    muted: "#7EA87E",
    heading: "#D6F5D6",
    link: "#72E672",
    border: "rgba(168, 216, 168, 0.18)",
  },
  {
    id: "charcoal",
    label: "Charcoal",
    mode: "dark",
    background: "#1E1E1E",
    surface: "#2A2A2A",
    text: "#D4D4D4",
    muted: "#A3A3A3",
    heading: "#F2F2F2",
    link: "#7DCFFF",
    border: "rgba(212, 212, 212, 0.16)",
  },
];

export const getBlogReadingThemeById = (id) =>
  BLOG_READING_THEMES.find((theme) => theme.id === id) || null;
